// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"affiliateCreationForm_checkbox__3Jxbl","input":"affiliateCreationForm_input__18i3N"};